import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation.js";
import { PRODUCT_CONFIG } from "../config/productConfig.js";

const LandingFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className="landing-footer">
      <div>
        <p className="landing-footer-name">{PRODUCT_CONFIG.name}</p>
        <p>{t("landing.footer.tagline")}</p>
      </div>
      <nav aria-label={t("landing.footer.navigation")}>
        <Link to="/about">{t("landing.nav.about")}</Link>
        <Link to="/roadmap">{t("landing.nav.roadmap")}</Link>
        <Link to="/news">{t("landing.nav.news")}</Link>
        <Link to="/terms">{t("landing.nav.terms")}</Link>
      </nav>
      <p className="landing-footer-meta">{t("landing.footer.copyright", { year: new Date().getFullYear() })}</p>
    </footer>
  );
};

export default LandingFooter;
